import { createReducer } from '@reduxjs/toolkit';
import { benchmarkActions } from '~/behaviors/actions/benchmark.actions';

const replaceCompanySettings = (state, action) => {
  return action.payload;
};

const companySettings = createReducer({}, (builder) => {
  builder.addCase(benchmarkActions.fetchCompanyBenchmarkSettings.fulfilled, replaceCompanySettings);
});

export { companySettings };
